// updateYouTubeButtons.js
export function setDataEventAttributes() {
  const youTubeComponents = document.querySelectorAll('.you-tube')

  youTubeComponents.forEach((parentElement) => {
    const eventLabel = parentElement.getAttribute('data-event-label')
    const eventValue = parentElement.getAttribute('data-event-value')

    const youTubePlayButtons = parentElement.querySelectorAll('.lty-playbtn')

    youTubePlayButtons.forEach((element) => {
      if (eventLabel) {
        element.setAttribute('data-event-label', eventLabel)
      }
      if (eventValue) {
        element.setAttribute('data-event-value', eventValue)
      }
    })
  })
}
